export interface LoginEntity {
    login: string
    password: string
}

export const createEmptyLogin = (): LoginEntity => ({
    login: "",
    password: ""
})
